(function ($) {
  'use strict';

  function parseSlideCount(value, fallback) {
    const parsed = Math.round(parseFloat(value));

    if (isNaN(parsed) || parsed < 1) {
      return fallback;
    }

    return parsed;
  }

  function initMiniaturesSliders(container) {
    if (typeof $ === 'undefined' || !$.fn || !$.fn.slick) {
      return;
    }

    const $context = container ? $(container) : $(document);

    $context.find('.camille-miniatures-gift-sets .miniatures-cards-slider').each(function () {
      const $slider = $(this);

      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      const slidesPerView = parseSlideCount($slider.data('slides-per-view'), 1);

      $slider.slick({
        dots: false,
        infinite: false,
        slidesToShow: slidesPerView,
        slidesToScroll: 1,
        prevArrow:
          '<button type="button" class="slick-arrow slick-prev" aria-label="Previous gift set"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10.014 15.738"><path d="M22848-22416.84l7.85,7.193-7.85,7.064" transform="translate(-22847.324 22417.576)" fill="none" stroke="#fff" stroke-width="2"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-arrow slick-next" aria-label="Next gift set"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10.014 15.738"><path d="M22848-22416.84l7.85,7.193-7.85,7.064" transform="translate(-22847.324 22417.576)" fill="none" stroke="#fff" stroke-width="2"/></svg></button>',
        responsive: [
          {
            breakpoint: 820,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false
            }
          }
        ]
      });
    });
  }

  function readyInit() {
    if (typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.slick) {
      initMiniaturesSliders();
    } else {
      setTimeout(readyInit, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', readyInit);
  } else {
    readyInit();
  }

  if (typeof document !== 'undefined' && !window.__miniaturesSliderBound) {
    window.__miniaturesSliderBound = true;

    document.addEventListener('shopify:section:load', function (e) {
      if (window.jQuery) {
        initMiniaturesSliders(e.target);
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (window.jQuery) {
        window.jQuery(e.target).find('.miniatures-cards-slider.slick-initialized').slick('unslick');
      }
    });
  }
})(window.jQuery || window.$);
